import PoliceClearanceModule from '@features/PoliceClearance/Police.Module';

const PoliceClearance = () => {
  return <PoliceClearanceModule />;
};

export default PoliceClearance;
